export default __webpack_public_path__ + "static/media/motivation-manager.7f561461.png";